import Vue from "vue";
import "./installCompositionApi";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PortalVue from "portal-vue";
import "./scss/styles.scss";
import "plyr/dist/plyr.css";
import "@web-components/scss/styles.scss";
import { fetchUnitDistribution } from "@dcc/lookup/unitdistribution/unitdistribution";
import {
  fetchFemaleConsumptionRisk,
  fetchMaleConsumptionRisk
} from "./lookup/consumptionrisk/consumptionrisk";
import VueGtm from "vue-gtm";

import { PluginObject } from "vue/types/umd";
import { fetchDictionaryValues } from "@dcc/lookup/dictionary/dictionary";

fetchUnitDistribution();
fetchMaleConsumptionRisk();
fetchFemaleConsumptionRisk();
fetchDictionaryValues();

Vue.use(PortalVue);

const root_element = document.getElementById("tool") as HTMLElement;
const gtmId = root_element.dataset.gtm;

//TODO: https://screenmedia.visualstudio.com/Drinkaware/_workitems/edit/23520
Vue.use(VueGtm as PluginObject<unknown>, {
  id: gtmId, // your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: process.env.NODE_ENV === "development", // whether or not display console logs debugs (optional)
  loadScript: true, // whether or not to load the GTM Script
  // (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router // pass the router instance to automatically sync with router (optional)
});

function getTrackerClientId(): void {
  var wga: any = (<any>window).ga;
  if (
    !store.state.$gtm.enabled() ||
    wga === undefined ||
    wga.getByName === undefined
  ) {
    setTimeout(getTrackerClientId, 500);
    return;
  }

  var tracker: any = wga.getAll()[0];
  var cid: string = tracker.get("clientId");
  store.state.clientId = cid;
}

Vue.config.productionTip = false;
let app = new Vue({
  store,
  router,
  render: (h) => h(App)
});
store.state.$gtm = (app.$gtm as unknown) as typeof VueGtm;
app.$mount("#tool");

getTrackerClientId();

if (window.location.search.length === 0) {
  router.replace("/");
} else {
  router.replace(`/actionplanresults${window.location.search}`);
}
